import { countryDeleteApi } from "../../api/country/countryDeleteApi"

type PayloadShape = Parameters<typeof countryDeleteApi>[0]

export async function countryDeleteService(payload: PayloadShape, token: string) {
	return await countryDeleteApi(payload, token)
}
